import { IProductListAnalyticsEvent } from '@epicuro-next/platform/event-tracker';
import { createAction, props } from '@ngrx/store';

export interface IBaseTrackEvent {
  name: string;
  properties: { [key: string]: string | number | undefined };
}

export const trackEvent = createAction(
  '[Event Tracker] Track Event',
  props<{ event: IBaseTrackEvent | IProductListAnalyticsEvent }>(),
);
